































import { Component, Vue } from 'vue-property-decorator';
import { ApiClient, apiClient } from '@/api/ApiClient';
import moment from 'moment';
import TickCross from '@/components/TickCross.vue';
import { download } from '@/utils/file';
import camelcase from 'camelcase';
import {
  createNotify,
  updateNotify,
  deleteNotify,
  notifyError,
  notifyErrorThrow,
  successNotify
} from "@/utils/formHelper";

@Component({
  components: {
    TickCross,
  },
})
export default class extends Vue {

  public get moment() {
    return moment;
  }

  // table filter
  public range: Date[] = [];
  public customerId: number = null;
  public applicationId: number = null;
  public orderByColumn: string = null;
  public orderByOrder: string = null;

  // filter option
  public states: any[] = [];

  // table
  public isTableLoading = false;

  public pageSize = 100;
  public total = 0;
  public currentPage = 1;

  public data: any[] = [];
  public customers: any[] = [];
  public applications: any[] = [];

  // filter
  public get filteredApplications() {
    return this.applications
    .filter(p =>
      (!this.customerId || p.customer.id === this.customerId)
    );
  }

  public mounted() {
    this.loadData();
  }

  // filter events
  public async onFilterCustomerChange() {
    this.applicationId = null;
    await Promise.all([
      this.loadApplications(),
      this.loadTemplate(),
    ]);
  }


  // table events
  public async onPaginationChange() {
    await this.loadTemplate();
    this.$scrollTo("#data-table");
  }

  // sort
  public async tableSortChange({ column, prop, order }) {
    if (prop && order) {
      this.orderByColumn = camelcase(prop.replace('.', '_'));
      this.orderByOrder = order.startsWith("asc") ? "ASC" : 'DESC';
    } else {
      this.orderByOrder = this.orderByColumn = null;
    }
    return this.loadTemplate();
  }

  //
  private async loadData() {
    await Promise.all([
      this.loadTemplate(),
      this.loadCustomers(),
      this.loadApplications(),
    ]);
  }

  private async loadCustomers() {
    const { data } = await apiClient.customers({
      take: Number.MAX_SAFE_INTEGER,
    });
    this.customers = data.data;
  }

  private async loadApplications() {
    if (!this.customerId) {
      return;
    }
    const { data } = await apiClient.applications({
      serviceId: 2,
      take: Number.MAX_SAFE_INTEGER,
      username: this.customers.find(c => c.id === this.customerId).account.username,
    });
    this.applications = data.data;
  }

  private async loadTemplate() {
    if (!this.customerId || !this.applicationId) {
      this.data = [];
      return;
    }

    this.isTableLoading = true;

    const { data } = await apiClient.postYcloudWhatsappTemplate(this.getFilter());

    this.total = data.count;
    this.data = data.data;
    this.isTableLoading = false;
  }

  private async onClickDeleteTemplate(wabaId: string, name: string, language: string) {
    try {
        await this.$confirm(`Are you sure to delete ${name} ${language}`, 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          })
      } catch (e) {
        return;
      }

      const data = {
        applicationId: this.applicationId,
        wabaId,
        name,
        language,
      };

    try {
      const result = await apiClient.deleteYcloudWhatsappTemplate(data);
      if (result.data.status === 200) {
        successNotify.bind(this)();
        await this.loadTemplate();
      } else {
        notifyError.bind(this)(result.data.statusText);
      }
    } catch (e) {
      notifyErrorThrow.bind(this)(e);
    }
  }

  private getFilter() {
    const range = this.range || [];

    return {
      take: this.pageSize,
      page: this.currentPage,

      orderByColumn: this.orderByColumn,
      orderByOrder: this.orderByOrder,

      customerId: this.customerId || undefined,
      applicationId: this.applicationId || undefined,

      from: range[0],
      to: range[1],
    };
  }

  private getStates(row: any) {
    if (row.statusReport && row.statusReport.whatsappMessage) {
      return row.statusReport.whatsappMessage.status;
    }

    return "";
  }
}
